import "./circular_btn.css";
import { Link } from "react-router-dom";

function CircularBtn({ text, link, variant = "primary", className = "", ...props }) {
    const isExternal = link && (link.startsWith("http") || link.startsWith("//"));

    if (isExternal) {
        return (
            <a
                href={link}
                className={`circular-btn ${variant} ${className}`}
                target="_blank"
                rel="noopener noreferrer"
                {...props}
            >
                {text}
            </a>
        );
    }

    return (
        <Link to={link || "#"} className={`circular-btn ${variant} ${className}`} {...props}>
            {text}
        </Link>
    );
}

export default CircularBtn;
